module.exports = __webpack_public_path__ + "static/media/korvue.369ee8c6.svg";